module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8017.da1a6391.png";